export const YOUTUBE_FEED = "https://www.googleapis.com/youtube/v3/videos?";
export const CHANNEL = "https://www.googleapis.com/youtube/v3/channels?";
export const COMMENTS_ON_VIDEO = "https://www.googleapis.com/youtube/v3/commentThreads?";
export const SEARCH = "https://www.googleapis.com/youtube/v3/search?";